export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-path/index.js
// module id = ../../../../d3-path/index.js
// module chunks = 3